"use client"
import {Link} from 'react-router-dom';
import React from 'react';

const ResponsiveMenu = () => {
    return (
        <>
            <ul>
                <li><Link to='/'>Home</Link></li>
                <li><Link to='/about-us'>About Us</Link></li>
                <li><Link to='/services'>Services</Link></li>
                <li><Link to='/portfolio'>Portfolio</Link></li>
                <li className='menu-item-has-children'><Link>Pages</Link>
                    <ul className='sub-menu'>
                        <li><Link to='/history'>Company History</Link></li>
                        <li><Link to='/team'>Company Organizational Structure</Link></li>
                        <li><Link to='/gallery'>Gallery</Link></li>
                        <li><Link to='/blog'>Blog</Link></li>
                        <li><Link to='/recruitment'>Recruitments</Link></li>
                    </ul>
                </li>
                <li><Link to='/contact-us'>Contact Us</Link></li>
            </ul>
        </>
    );
};

export default ResponsiveMenu;